import dynamic from 'next/dynamic'

import type { CapWidgetProps } from './CapWidgetInner'

/** SSR 安全的 Cap widget 封装，仅在客户端加载内嵌 cap.min.js */
export const CapWidget = dynamic<CapWidgetProps>(
  () => import('./CapWidgetInner').then((module) => module.CapWidgetInner),
  {
    ssr: false,
  },
)
